import { HStack, IconButton, useDisclosure, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, Box } from "@chakra-ui/react";
import React, { useRef } from "react";
import AdminLeftSideBar from "./components/AdminLeftSideBar";
import { Outlet, useLocation } from "react-router-dom";
import DashboardCard from "./components/DashboardCard";
import { Helmet } from "react-helmet";
import { GiHamburgerMenu } from "react-icons/gi";

const Admin = () => {
  const location = useLocation();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = useRef();

  return (
    <>
      <Helmet>
        <title>Admin | Techy India</title>
      </Helmet>

      {/* Mobile Hamburger Button */}
      <Box
        display={["flex", "flex", "none"]}
        position="fixed"
        top="1rem"
        left="1rem"
        zIndex={1000}
      >
        <IconButton
          ref={btnRef}
          icon={<GiHamburgerMenu />}
          onClick={onOpen}
          colorScheme="red"
          size="sm"
          aria-label="Open Menu"
        />
      </Box>

      {/* Mobile Drawer */}
      <Drawer
        isOpen={isOpen}
        placement="left"
        onClose={onClose}
        finalFocusRef={btnRef}
      >
        <DrawerOverlay />
        <DrawerContent maxW="260px">
          <DrawerCloseButton />
          <Box pt="3rem">
            <AdminLeftSideBar onClose={onClose} />
          </Box>
        </DrawerContent>
      </Drawer>

      {/* Desktop + Tablet Layout */}
      <HStack align="start" justify="start" w="100%" minH="100vh">
        {/* Desktop Sidebar */}
        <Box display={["none", "none", "flex"]} minH="100vh" borderRight="1px solid #f0f0f0">
          <AdminLeftSideBar />
        </Box>

        {/* Main Content */}
        <Box flex="1" w="100%" pt={["3.5rem", "3.5rem", "0"]}>
          {location.pathname === "/admin" && <DashboardCard />}
          {location.pathname === "/admin/" && <DashboardCard />}
          <Outlet />
        </Box>
      </HStack>
    </>
  );
};

export default Admin;
